import ModalDelete from 'components/modal/ModalDelete';
import useDeleteCustomSIPHeader from '../queries/useDeleteCustomSIPHeader';

const CustomSIPHeaderDeleteModal = ({
    headerData,
    resetToMainTable,
    isOpen,
    onClose,
}) => {
    const { mutate: deleteHeader, isLoading } = useDeleteCustomSIPHeader(
        resetToMainTable,
        onClose,
    );

    const handleDelete = () => {
        deleteHeader(headerData.id);
    };

    return (
        <ModalDelete
            type="Custom SIP Header"
            name={headerData.name}
            isOpen={isOpen}
            handleClose={onClose}
            handleSubmit={handleDelete}
            closeWalkthroughId=""
            deleteWalkthroughId=""
            isDisabled={false}
            isLoading={isLoading}>
            Are you sure you want to delete this custom SIP header? This action
            cannot be undone.
        </ModalDelete>
    );
};

export default CustomSIPHeaderDeleteModal;
